import http from '@/api/http';
import type { ShippingDirection } from '@/contexts/DirectionContext';
import type { OfferCard } from '../interfaces/offer-card.interface';

export const offerCardsApi = {
  /**
   * Lista de carduri pentru pagina `/app/offers`.
   * @param companyId când e setat, restricționează la firma respectivă.
   */
  async get(companyId?: number, direction?: ShippingDirection): Promise<OfferCard[]> {
    const params = {
      ...(typeof companyId === 'number' ? { companyId } : {}),
      ...(direction ? { direction } : {}),
    };
    const response = await http.get('/offers/cards', { params });
    return (response.data?.data as OfferCard[]) ?? [];
  },
};
